<template>
  <main>
    <main class="sv-body">
      <nuxt />
    </main>
    <willis-footer />
    <vue-snotify />
  </main>
</template>

<script>
import WillisFooter from '@/components/WillisFooter'

export default {
  components: { WillisFooter },
  middleware: 'authenticated'
}
</script>

<style lang="scss" scoped>
.sv-body {
  min-height: calc(100vh - #{$footer-height});
}
</style>
